export default __webpack_public_path__ + "imgs/background_dots.png";